module.exports = __webpack_public_path__ + "static/media/play.49b72900.svg";